module.exports = __webpack_public_path__ + "img/facilities_icon.3fb3da6f.svg";